/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_Start_AriaInputs */



/**
* | output |
* | --- |
* | "Go to Start" |
*
* @param {Video_Export_Preview_Go_To_Start_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_start_aria = /** @type {((inputs?: Video_Export_Preview_Go_To_Start_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_Start_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller au debut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Start")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai all'inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти в меню «Пуск»")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回开头")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタートへ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o Início")
	return /** @type {LocalizedString} */ ("Go to Start")
});